import { FournisseurModel } from './../../../../shared/models/societe-linked/fournisseur.model';
import { SimpleQueryResponse } from './../../../../shared/dtos/simpleQueryResponse';
import { FilterFournDTO } from './../../../../shared/dtos/filterFournDTO';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { FournisseurService } from './../../../../shared/services/societe-linked/fournisseur.service';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Component, Input, OnInit, ViewChild, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-fournisseur-list',
  templateUrl: './fournisseur-list.component.html',
  styleUrls: ['./fournisseur-list.component.scss']
})
export class FournisseurListComponent implements OnChanges {
// tslint:disable-next-line: max-line-length
displayedColumns: string[] = ['code', 'libelle', 'siret', 'adresse', 'tel'];
length: number;
pageIndex: number;
pageSize = 10;
sortState: Sort = { active: 'code', direction: 'asc' };
@Input() filtreData: FilterFournDTO;
@Input() simpleQueryFournResponse: SimpleQueryResponse<FournisseurModel> = null;
matDataSourceFourn: MatTableDataSource<FournisseurModel> = new MatTableDataSource<FournisseurModel>();
@Input() dataSource: FournisseurModel[];
@Output() updateFournisseur = new EventEmitter<FournisseurModel>();

@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
@ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(private fournisseurService: FournisseurService) {
   }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line: max-line-length
    if (changes.dataSource && changes.dataSource.currentValue && changes.simpleQueryFournResponse && changes.simpleQueryFournResponse.currentValue) {
      this.dataSource = changes.dataSource.currentValue.slice();
      this.matDataSourceFourn = new MatTableDataSource(this.dataSource);
      this.length = this.simpleQueryFournResponse.count;
      this.pageIndex = this.simpleQueryFournResponse.pageNumber;
      this.pageSize = this.simpleQueryFournResponse.pageSize;
    }
  }

  changePage(event?: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filtreData.pageNumber = event.pageIndex;
    this.filtreData.pageSize = event.pageSize;

    this.loadPage();
  }

  trieTab(sort: Sort): void {
    this.sortState = sort;
    this.filtreData.descending = sort.direction === 'desc' ? true : false;
    this.filtreData.order = sort.active;
    this.loadPage();
  }

  selectFournisseur(fournisseur: FournisseurModel): void{
    this.updateFournisseur.emit(fournisseur);
  }

  loadPage(): void {
    this.fournisseurService.getFiltredFournisseur(this.filtreData).subscribe((data: SimpleQueryResponse<FournisseurModel>) => {
      this.simpleQueryFournResponse = data;
      this.dataSource = data.objets;
      this.length = this.simpleQueryFournResponse.count;
      // tslint:disable-next-line: max-line-length
      const datas = this.dataSource.slice();
      this.matDataSourceFourn = new MatTableDataSource(datas.slice(0, this.pageSize));
    });
  }
}
